module.exports = __webpack_public_path__ + "img/box-open.03de4256.svg";